export default "__VITE_ASSET__7Pl55J0S__"